import palette from './palette';
import { createInteractionStates } from './colorUtils';

// Core brand colors
export const brandColors = {
  primary: palette.brand.primary,
  secondary: palette.brand.secondary,
  tertiary: palette.brand.tertiary,
} as const;

// Interaction states
export const interactions = {
  primary: createInteractionStates(brandColors.primary),
  secondary: createInteractionStates(brandColors.secondary),
};

// Background configurations for different themes
export const backgrounds = {
  dark: {
    default: palette.backgrounds.onboarding,
    paper: palette.backgrounds.stepCard,
    card: palette.backgrounds.card,
    modal: palette.backgrounds.modal,
    footer: palette.backgrounds.footer,
  },
  light: {
    default: palette.gray[50],
    paper: palette.white,
    card: palette.white,
    modal: palette.white,
    footer: palette.gray[100],
  },
} as const;
